<template>
  <van-overlay show z-index="1000">
    <div class="text-white text-medium pt-10 relative">
      <div class="text-center text-lg">
        <span>请用微信识别下方二维码登记领奖</span>
      </div>
      <template v-if="isTest">
        <div class="text-center text-red">
          <span> (测试答题，不真实发放红包)</span>
        </div>
      </template>
      <div class="text-center">
        <div class="mt-4">
          <span> 直接分享该二维码，将无法获得分享奖励</span>
        </div>
        <div class="mt-2">
          <vue-qr :text="url" />
        </div>
      </div>
      <ul class="px-5 mt-5 leading-base">
        <li class="mb-2">分享领红包方法：</li>
        <li class="mb-2">1.用手机微信扫码打开问卷；</li>
        <li class="mb-2">2.点击右上角【...】分享答卷给好友或发布到朋友圈；</li>
        <li class="">3.好友答卷并符合要求，系统会将奖励自动发放到您的“调研工厂+”公众号中。</li>
      </ul>
      <span class="absolute" style="top: 40px; right: 16px" @click="$emit('close')">
        <van-icon name="cross" class="text-large" />
      </span>
    </div>
  </van-overlay>
</template>

<script>
import VueQr from 'vue-qr'

export default {
  name: 'ReceiveShare',
  components: { VueQr },
  props: {
    isTest: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      required: true
    }
  }
}
</script>
